module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_56.90018ab9.png";